import { Link } from 'react-router-dom';
import { InstagramLogo, YoutubeLogo, EnvelopeSimple } from '@phosphor-icons/react';
import { LOGO_URL } from '../lib/brand';

const Footer = () => {
  return (
    <footer className="relative bg-[#0F1A2E] text-white" data-testid="site-footer">
      {/* Thin orange accent strip — sports-brand touch */}
      <div className="h-1 bg-gradient-to-r from-[#FF6A00] via-[#FF8A33] to-[#FF6A00]" aria-hidden="true" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand block */}
          <div className="md:col-span-6">
            <div className="flex items-center gap-3 mb-5">
              <img src={LOGO_URL} alt="Beyond Ball India" className="h-11 w-11 rounded-full object-contain ring-2 ring-white/10 bg-[#0F1A2E]" />
              <div className="leading-tight">
                <div className="text-lg font-extrabold tracking-tight">Beyond Ball</div>
                <div className="text-[10px] font-bold tracking-[0.32em] text-[#FF6A00] uppercase">India</div>
              </div>
            </div>
            <p className="text-white/65 text-sm sm:text-base leading-relaxed max-w-md mb-7">
              India&apos;s home for basketball tournaments. Discover, register, and play across every city.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.instagram.com/beyondballindia"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 rounded-full bg-white/8 hover:bg-[#FF6A00] text-white flex items-center justify-center transition-colors border border-white/10 hover:border-[#FF6A00]"
                data-testid="footer-instagram"
                aria-label="Instagram"
              >
                <InstagramLogo size={19} weight="bold" />
              </a>
              <a
                href="https://youtube.com/@beyondballindia"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 rounded-full bg-white/8 hover:bg-[#FF6A00] text-white flex items-center justify-center transition-colors border border-white/10 hover:border-[#FF6A00]"
                data-testid="footer-youtube"
                aria-label="YouTube"
              >
                <YoutubeLogo size={19} weight="bold" />
              </a>
            </div>
          </div>

          {/* Platform */}
          <div className="md:col-span-3">
            <h4 className="text-[10px] font-bold tracking-[0.28em] uppercase text-[#FF6A00] mb-5">Platform</h4>
            <div className="flex flex-col gap-3">
              <Link to="/tournaments" className="text-sm text-white/80 hover:text-white transition-colors" data-testid="footer-tournaments">Tournaments</Link>
              <Link to="/how-to-list" className="text-sm text-white/80 hover:text-white transition-colors" data-testid="footer-list-tournament">List Tournament</Link>
              <Link to="/about" className="text-sm text-white/80 hover:text-white transition-colors" data-testid="footer-about">About</Link>
              <Link to="/faq" className="text-sm text-white/80 hover:text-white transition-colors" data-testid="footer-faq">FAQ</Link>
            </div>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <h4 className="text-[10px] font-bold tracking-[0.28em] uppercase text-[#FF6A00] mb-5">Contact</h4>
            <a
              href="mailto:beyondballindia@gmail.com"
              className="inline-flex items-center gap-2.5 text-sm text-white/80 hover:text-white break-all transition-colors"
              data-testid="footer-email"
            >
              <span className="w-9 h-9 rounded-full bg-white/8 border border-white/10 flex items-center justify-center flex-shrink-0">
                <EnvelopeSimple size={14} weight="bold" />
              </span>
              beyondballindia@gmail.com
            </a>
          </div>
        </div>

        <div className="mt-12 pt-7 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-xs text-white/50">© 2026 Beyond Ball India. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-xs text-white/65 hover:text-white transition-colors" data-testid="footer-privacy">Privacy</Link>
            <Link to="/terms" className="text-xs text-white/65 hover:text-white transition-colors" data-testid="footer-terms">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
